// extracted by mini-css-extract-plugin
export default {"main-container":"PaymentGatewayCallback_main-container__A0DAq"};